document.querySelectorAll('.utility-primary__item--has-children > a.utility-primary__link--depth-0')
	.forEach(anchor => {
		anchor.addEventListener('click', function (e) {

			if (window.innerWidth > 991) return;

			e.preventDefault();

			this.classList.toggle('mobile-open');

			let menu_sub_item = this.nextElementSibling;

			if (!menu_sub_item) return; // safety check

			menu_sub_item.classList.toggle('utility-primary__items--depth-1--open');
			// it should be a display block before collapse action

			if (menu_sub_item.style.maxHeight) {
				// Collapse
				// console.log("Closing submenu");
				menu_sub_item.style.maxHeight = null;
			} else {
				// Expand
				// console.log("Opening submenu, height:", menu_sub_item.scrollHeight);
				menu_sub_item.style.maxHeight = menu_sub_item.scrollHeight + "px";
			}
		});
	});
